export default {
  requestReturn: '申请退仓',
  requestScrapping: '申请报废',
  batchReturn: '批量退仓',
  batchScrapping: '批量报废',
  productOffshelfForScrap: '商品需要下架后, 才允许申请报废',
  productOffshelfForReturn: '品需要下架后, 才允许申请退仓取件',
  all: '所有',
  warehouseProductNumber: '仓库货号',
  warehouseNumber: '仓库编号',
  warehouseName: '仓库名称',
  productName: '商品名称',
  productImage: '商品图片',
  productSpecifications: '商品规格',
  availableInventory: '可用库存数量',
  returnQuantity: '退仓数量',
  pickupMethod: '取件方式',
  selfPickup: '到仓库自提',
  estimatedCollectionTime: '预计取件时间',
  confirm: '确认',
  cancel: '取消',
  applicationSuccess: '申请提交成功',
  promptPickup: '请及时前往仓库取件',
  // 打印页面相关
  pleasePickupPromptly: '请及时前往仓库取件',
  orderNumber: '订单编号',
  warehouseContact: '仓库联系人',
  contactPhone: '联系人电话',
  warehouseAddress: '仓库地址',
  printVoucher: '打印凭证',
  downloadPickupVoucher: '下载取货凭证',
  returnApplicationSubmittedSuccessfully: '退仓申请提交成功',
  scrapApplicationSubmittedSuccessfully: '报废申请提交成功',
  returnDetails: '退仓详情',
  scrapDetails: '报废详情',
  express: '快递',
  homeDelivery: '送货上门',
  other: '其它',
  unknownMethod: '未知方式',
  generatingImage: '正在生成图片，请稍候...',
  returnVoucherFilename: '申请凭证.png',
  imageGeneratedSuccessfully: '图片生成成功',
  generateImageFailed: '生成图片失败，请重试',
  featureOnlyAvailableInClient: '此功能仅在客户端可用',
  downloadImageFailed: '下载图片失败',
  preparingToPrint: '正在准备打印，请稍候...',
  status: '状态',
  pendingReview: '待审核',
  pendingProcessing: '待处理',
  pendingPickup: '待取件',
  completed: '已完成',
  cancelled: '已取消',
  contactPerson: '联系人',
  // 表格相关
  returnNumber: '退仓编号',
  returnOrderNumber: '退仓客户订单号',
  requestReturnQuantity: '申请退仓数量',
  actualOutboundQuantity: '实际出库数量',
  estimatedPickupTime: '预计取件时间',
  returnCompletionTime: '退仓完成时间',
  printPickupVoucher: '打印取件凭证',
  unknownStatus: '未知状态',
  printSlip: '打印凭证',
  viewApplicationList: '查看申请列表',
  returnApplicationRecords: '退仓申请记录',
  batchPrintSlip: '批量打印凭证',
  scrapApplicationRecords: '报废申请记录',
  scrapOrderNumber: '报废客户订单号',
  pendingReceive: '退仓待取件',
  selectProducts: '请选择要申请的商品',
  selectPickupTime: '请选择预计取件时间',
  enterProductQuantity: '请输入商品数量',
  returnTip: '请凭打印退仓单在周一至周五（肯尼亚 8:00-12:00 & 13:00-15:00）取件。申请提交后不可撤销，库存将冻结但仍计仓储费。超期未取退仓单将关闭，您需重新申请。您确定申请退仓吗？',
  scrapTip: '本次将报废该 SKU 全部 FBK 下架库存，不含后续退回库存。报废成功（状态：已完成）次日起停止仓储费。',
  agreeToTerms: '我同意规则和条款',
  confirmReturn: '确认退仓',
  confirmScrap: '确认报废',
  inventoryCannotBeZero: '库存不能为0',
  scrapNumber: '报废编号',
  scrapQuantity: '报废数量',
  applicationTime: '申请时间',
  completionTime: '完成时间',
  operation: '操作',
  details: '详情',
  selectWarehouse: '请选择仓库',
  enterFrontSku: '请输入前台SKU',
  enterListingId: '请输入Listing ID',
  search: '搜索',
  startTime: '开始时间',
  endTime: '结束时间',
  batchPrintVoucher: '批量打印凭证',
  viewScrapList: '查看报废列表',
  viewReturnList: '查看退仓列表',
  nonOffShelfProductsFiltered: '非下架状态的商品已过滤',
  productNotOffShelf: '未下架商品',
  pickupRules: '取件规则'
}
